import { render, staticRenderFns } from "./PayeeInfoInputFile.vue?vue&type=template&id=61d9ef7f&scoped=true&"
import script from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoInputFile.vue?vue&type=style&index=0&id=61d9ef7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9ef7f",
  null
  
)

export default component.exports